var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c((_vm.cpName),{tag:"component",attrs:{"pageConfig":(_vm.pageConfig),"info":(_vm.info)}})
}
var staticRenderFns = []

export { render, staticRenderFns }